import taskManagerApi from '@/features/shared/services/taskManagerApi';
import { ObjectUtil } from '@/features/shared/utils/ObjectUtil';
/**
 * Fetch charges with optional pagination, filtering, and an "all" flag.
 */
export async function fetchCharges(page, filters, all = false, limit) {
    try {
        const params = {
            ...(page ? { page } : {}),
            ...(filters || {}),
            ...(all ? { all: true } : {}),
            ...(limit ? { limit } : {}),
        };
        const response = await taskManagerApi.get('/charge', { params });
        return response.data.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la récupération des charges");
        }
    }
}
/**
 * Create a new charge.
 */
export async function addCharge(charge) {
    try {
        console.log(charge);
        const response = await taskManagerApi.post("/charge", charge);
        return response.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de l'ajout de la charge");
        }
    }
}
/**
 * Update an existing charge.
 */
export async function updateCharge(charge) {
    try {
        const updatedCharge = ObjectUtil.omitField(charge, 'id');
        console.log(charge);
        const response = await taskManagerApi.put(`/charge/${charge.id}`, updatedCharge);
        return response.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la modification de la charge");
        }
    }
}
/**
 * Delete a charge by its ID.
 */
export async function deleteCharge(id) {
    try {
        const response = await taskManagerApi.delete(`/charge/${id}`);
        return response.data;
    }
    catch (error) {
        if (error instanceof Error) {
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la suppression de la charge");
        }
    }
}
export async function fetchTaskCharges(taskId) {
    const response = await taskManagerApi.get(`/task/${taskId}/charges`);
    return response.data.data.taskCharges;
}
